import { injectGlobal } from 'styled-components';
import { Theme } from './theme';
import { normalize } from 'polished';

injectGlobal`
  ${normalize()}
  
  * {
    box-sizing: border-box;
  }
  
  html, body, button, input, optgroup, select, textarea {
    font-family: ${Theme.fontDefault}, sans-serif;
  }
`;

export * from './fonts/web-fonts';
export * from './fonts/hui-icons-fonts';
export { Card, CardHeading, Jumbotron, StatusCard, SpotsCard, BusinessCard } from './card';
export { Avatar } from './avatar';
export { ImageCover } from './images';
export { Icon } from './icons';
export { Button } from './buttons';
export { Breadcrumbs } from './breadcrumbs';
export { Section, Row, Col, Container, ContainerFluid } from './grid';
export {
  HeadingOne,
  HeadingTwo,
  HeadingThree,
  HeadingFour,
  HeadingFive,
  HeadingSix,
  ParagraphTitle,
  Paragraph,
  SubParagraph,
  SmallText,
  TinyText,
  Label,
  FooterText,
  HorizontalRule
} from './typography';
export { HeroInput, Input, IconInput, InputGroup, TextArea } from './inputs';
export { Theme } from './theme';
export { AutoComplete } from './autocomplete';
export { SocialBar, SocialBarMobile, BackToTopButton } from './bars';
export { Header } from './header';
export { HeaderV2 } from './header-v2';
export { HeaderV2Static } from './header-v2-static';
export { Footer } from './footer';
export { HeaderSimple } from './simple/header-simple';
export { FooterSimple } from './simple/footer-simple';
export { Carousel } from './carousel/carousel';
export { Slick } from './carousel/slick';
export { SearchBar } from './search-bar';
export { LocationAutocomplete } from './location-autocomplete';
export { LeadPackUpsellModal } from './lead-pack-upsell/LeadPackUpsellModal';
export { Alexa } from './alexa/index';
export { Alert } from './alert';
export { Modal } from './modal';
